import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Confirm } from 'semantic-ui-react';
import { useDeleteCmsUserMutation } from 'api/v2/userApi';
import { useDispatch, useSelector } from 'react-redux';
import { listCMSUsers } from 'actions/UserActions';
import { IState } from 'reducers/reducers';
import { CMSUser } from '@visikon/core-models/user';

export function DeleteUserButton({ user }: { user: CMSUser }) {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const mutation = useDeleteCmsUserMutation();
  const namespace = useSelector((state: IState) => state.users.namespaces.find((ns) => ns.name === user.namespace));

  const onConfirm = async () => {
    mutation.mutate(user._id, {
      onSuccess: () => {
        dispatch(listCMSUsers({ namespace: user.namespace }));
        history.replace(`/namespaces/${namespace!.name}/${namespace!._id}`);
      },
    });

    setOpen(false);
  };

  return (
    <>
      <Confirm open={open} onConfirm={onConfirm} header={`Delete ${user.username}?`} content="This action cannot be undone!" />
      <Button disabled={mutation.isLoading} loading={mutation.isLoading} color="red" onClick={() => setOpen(true)}>
        Delete User
      </Button>
    </>
  );
}
